import { render } from "./AssistenzaTecnica_nascosto_ricerca.vue?vue&type=template&id=8fdb1e9c&scoped=true"
import script from "./AssistenzaTecnica_nascosto_ricerca.vue?vue&type=script&lang=js"
export * from "./AssistenzaTecnica_nascosto_ricerca.vue?vue&type=script&lang=js"

import "./AssistenzaTecnica_nascosto_ricerca.vue?vue&type=style&index=0&id=8fdb1e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fdb1e9c"]])

export default __exports__